import React, { createContext, useContext } from "react";
import { message } from "antd";

const ToastContext = createContext(null);

export function useToast() {
  return useContext(ToastContext);
}

export const ToastProvider = ({ children }) => {
  const errorToast = msg => {
    message.error(msg, 6);
  };

  const warningToast = msg => {
    message.warning(msg, 6);
  };

  const successToast = msg => {
    message.success(msg, 6);
  };

  return (
    <ToastContext.Provider value={{ successToast, warningToast, errorToast }}>
      {children}
    </ToastContext.Provider>
  );
};
